module.exports = __webpack_public_path__ + "img/lineup-1.b25f4de0.jpg";